import { render, staticRenderFns } from "./BodyMessage.vue?vue&type=template&id=2042293e&scoped=true&"
import script from "./BodyMessage.vue?vue&type=script&lang=js&"
export * from "./BodyMessage.vue?vue&type=script&lang=js&"
import style0 from "./BodyMessage.vue?vue&type=style&index=0&id=2042293e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042293e",
  null
  
)

export default component.exports